export default async function Fetch(url, params) {
  let fetchParams = params;
  if (!fetchParams) {
    fetchParams = { headers: {} };
  }
  fetchParams = {
    ...fetchParams,
    headers: {
      ...fetchParams.headers,
    },
  };

  const res = await fetch(url, fetchParams);

  if (res.status === 401) {
    const refreshRes = await fetch('/azd/verify');

    if (refreshRes.status !== 200) {
      window.location = `${window.location.origin}/azd/redirect?`
        + `redirect-uri=${encodeURIComponent((window.location.pathname + window.location.hash)) || '/'}`;
      return null;
    }

    const secondAttemptRes = await fetch(url, fetchParams);
    if (secondAttemptRes.status === 401) {
      throw new Error(`fetch ${url} returned 401 right after refresh`);
    }

    return secondAttemptRes;
  }

  return res;
}
